export default __webpack_public_path__ + "static/media/tokped.6da45fe1.svg";